import React from 'react';
import styles from './Activities.module.scss';

const Activities = () => {
  return (
    <div className={styles.activities}>
      <h2>Направления деятельности</h2>

      <ul className={styles.list}>
        <li>
          <h3>Городской диалог</h3>
          <p>
            Коммуникационная площадка для&nbsp;органов власти, экспертов, бизнеса, горожан и&nbsp;локальных сообществ.
          </p>
        </li>
        <li>
          <h3>Комплексное благоустройство</h3>
          <p>
            Проектный офис – региональный центр компетенций по&nbsp;вопросам комплексного благоустройства
            и&nbsp;формирования комфортной городской (сельской) среды муниципальных образований Красноярского края
          </p>
        </li>
        <li>
          <h3>Городское планирование и развитие</h3>
          <p>
            Проектный офис по&nbsp;формированию стратегий пространственного развития территорий муниципальных
            образований Красноярского края, координационный центр по&nbsp;реализации данных проектов.
          </p>
        </li>
        <li>
          <h3>Визуальная среда</h3>
          <p>
            Консультационно-методический центр по&nbsp;вопросам формирования архитектурно-художественного облика
            населённых пунктов края и&nbsp;совершенствования нормативно-правовой базы муниципальных образований
            в&nbsp;сфере благоустройства.
          </p>
        </li>
        <li>
          <h3>Экспертное сопровождение</h3>
          <p>
            Образовательно-просветительская площадка и&nbsp;организационный центр по&nbsp;привлечению экспертов
            из&nbsp;различных отраслей к&nbsp;поискам вариантов решения актуальных для&nbsp;Красноярского края
            и&nbsp;города Красноярска вопросов (в&nbsp;том&nbsp;числе путём организации творческих конкурсов),
            к&nbsp;сопровождению общественно значимых проектов.
          </p>
        </li>
      </ul>
    </div>
  );
};

export default Activities;
